// ui
import { Box, Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

interface DeletePaymentModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  deletePaymentInf: {
    status: null | "loading" | "open" | "success" | "failed";
    name: string;
    key: { [key: string]: string };
    message: string;
  };
  setDeletePaymentInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    name: string;
    key: { [key: string]: string };
    message: string;
  }) => void;
  deletePayment: () => void;
}

export function DeletePaymentModal(props: DeletePaymentModalProps) {
  const {
    onModal,
    swCloseModal,
    deletePaymentInf,
    setDeletePaymentInf,
    deletePayment,
  } = props;
  const pathname = useAtomValue(AppAtoms.pathname);

  const footer =
    deletePaymentInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          data-testid="delete-payment-close"
          onClick={swCloseModal}
        >
          閉じる
        </PoButton>
        <PoButton
          variant="primary"
          data-testid="delete-payment-submit"
          onClick={deletePayment}
        >
          削除
          <DeleteIcon fontSize="small" />
        </PoButton>
      </>
    ) : deletePaymentInf.status === "success" ? (
      <PoButton
        variant="secondary"
        data-testid="delete-payment-success-close"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : deletePaymentInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        data-testid="delete-payment-failed-back"
        onClick={() =>
          setDeletePaymentInf({
            ...deletePaymentInf,
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title={deletePaymentInf.name}
      onClose={swCloseModal}
      testidPrefix="delete-payment"
      footer={footer}
    >
      {deletePaymentInf.status === "open" ? (
        <Alert
          severity="error"
          sx={{
            bgcolor: "var(--sem-error-bg, #f6d5d1)",
            color: "var(--sem-error, #a53229)",
            fontSize: 12,
            borderRadius: "var(--radius-md, 10px)",
            p: "var(--sp-3, 12px) var(--sp-4, 16px)",
            "& .MuiAlert-icon": { color: "var(--sem-error, #a53229)" },
          }}
        >
          {deletePaymentInf.name}
          後、データは復元できません。
          {pathname !== "/outside_entry_form" ? (
            <>
              <br />
              確定済の明細には影響は発生しません。
            </>
          ) : null}
        </Alert>
      ) : deletePaymentInf.status === "success" ? (
        <Box className="result-state -success" data-testid="result-state-success">
          <span className="rs-title">
            {deletePaymentInf.name}
            に成功しました。
          </span>
        </Box>
      ) : deletePaymentInf.status === "failed" ? (
        <Box className="result-state -failed" data-testid="result-state-failed">
          <span className="rs-title">{deletePaymentInf.message}</span>
        </Box>
      ) : null}
    </PoModalShell>
  );
}
